import startsWith from 'lodash/startsWith'

export const formatPhoneNumber = (phoneNumber: string = '') => {
  const phoneNumberWithoutSpaces = phoneNumber.split(` `).join(``)

  const hasCountryCode = startsWith(phoneNumberWithoutSpaces, '+')
  const countryCode = hasCountryCode ? phoneNumberWithoutSpaces.slice(0, 4) : ''

  const phoneNumberWithoutCountryCode = hasCountryCode
    ? phoneNumberWithoutSpaces.slice(4)
    : phoneNumberWithoutSpaces

  const numberSegments = phoneNumberWithoutCountryCode.match(/.{1,3}/g)
  const numberWithSpaces = numberSegments?.join(`\u00A0`)
  const formattedNumber = hasCountryCode
    ? `${countryCode}\u00A0${numberWithSpaces}`
    : numberWithSpaces

  return formattedNumber ?? ``
}

type TPhoneNumberValues = {
  phonePrefix: string
  phoneNumber: string
}

/**
 * Joins `phonePrefix` with `phoneNumber`.
 */
export const getFullPhoneNumber = ({ phonePrefix, phoneNumber }: TPhoneNumberValues) => {
  return `${phonePrefix.trim()}${phoneNumber.trim()}`
}
